import * as _Int from "../settings/interfaces";
import { hideInstructionPanel } from "./instructions";
import * as stamps from './stamps';

import { options } from "../settings/config";

import { drag } from "./main";

let card: HTMLDivElement;
let cardInfo: _Int.Path.ICard;

let cardWidth: number;
let cardHeight: number;
let isDown: boolean = false;
const touchStartPos: any = { x: 0, y: 0 };
let hDropArea: number;
let vDropArea: number;

let leftHover: boolean = false;
let rightHover: boolean = false;
let topHover: boolean = false;
let bottomHover: boolean = false;

let callback: (...args: any) => void;

let decisionGroupDOM: HTMLDivElement;

function setGlobals(): void {

  cardWidth = card.getBoundingClientRect().width;
  cardHeight = card.getBoundingClientRect().height;
  hDropArea = (cardWidth / 100) * 80;
  vDropArea = (cardHeight / 100) * 80;

}

function touchDown(e: MouseEvent & TouchEvent): void {

  let evt: any;
  isDown = true;
  card.style.transition = `none`;
  if (e.type === "mousedown") {
    evt = e;
  } else {
    const touch: Touch = e.touches[0];
    evt = touch;
  }
  touchStartPos.x = evt.clientX;
  touchStartPos.y = evt.clientY;

  // hideInstructionPanel();
  if (options.stamps.default) {
    stamps.init(card, options.stamps.inverse);
  }
}

function touchMove(e: MouseEvent & TouchEvent): void {
  if (isDown) {
    drag.now = true;
    let offsetX: number, offsetY: number, evt: any;
    if (e.type === "mousemove") {
      evt = e;
      e.preventDefault();
    } else {
      evt = e.touches[0] as Touch;
    }
    const rate: number = 3;
    offsetX = (evt.clientX - touchStartPos.x) / rate;
    offsetY = (evt.clientY - touchStartPos.y) / rate;

    if (cardInfo.topCard && cardInfo.bottomCard) {
      offsetY = evt.clientY - touchStartPos.y;
    } else {
      if (cardInfo.topCard) {
        if (evt.clientY - touchStartPos.y >= 0) {
          offsetY = evt.clientY - touchStartPos.y;
        }
      }
      if (cardInfo.bottomCard) {
        if (evt.clientY - touchStartPos.y < 0) {
          offsetY = evt.clientY - touchStartPos.y;
        }
      }
    }

    if (cardInfo.leftCard && cardInfo.rightCard) {
      offsetX = evt.clientX - touchStartPos.x;
    } else {
      if (cardInfo.leftCard) {
        if (evt.clientX - touchStartPos.x >= 0) {
          offsetX = evt.clientX - touchStartPos.x;
        }
      }
      if (cardInfo.rightCard) {
        if (evt.clientX - touchStartPos.x < 0) {
          offsetX = evt.clientX - touchStartPos.x;
        }
      }
    }

    const expo: number = (offsetX < 0 ? -Math.pow(offsetX, 2) : Math.pow(offsetX, 2));
    const rotation: number = (25 / (Math.pow(cardWidth, 2))) * expo;
    card.style.transform = `translate(${offsetX}px, ${offsetY}px) rotate(${rotation}deg)`;

    if (offsetY < (-cardHeight) + vDropArea) {
      if (!topHover) { // swipe up
        topHover = true;
        bottomHover = false;
      }
    } else if (offsetY > cardHeight - vDropArea) {
      if (!bottomHover) { // swipe down
        topHover = false;
        bottomHover = true;
      }
    } else {
      if (topHover || bottomHover) {
        topHover = false;
        bottomHover = false;
      }
      if (offsetX < (-cardWidth) + hDropArea) {
        if (!leftHover) { // swipe left
          rightHover = false;
          leftHover = true;
        }
      } else if (offsetX > cardWidth - hDropArea) {
        if (!rightHover) { // swipe right
          leftHover = false;
          rightHover = true;
        }
      } else {
        if (leftHover || rightHover) {
          leftHover = false;
          rightHover = false;
        }
      }
    }

    if (options.stamps.default) {
      stamps.fade(offsetX, offsetY, cardHeight - vDropArea, cardWidth - hDropArea);
    }

    decisionGroupDOM = card.querySelector("#decision-group") as HTMLDivElement;
    if (decisionGroupDOM && !decisionGroupDOM.classList.contains("hide")) {
      decisionGroupDOM.classList.add("hide");
    }

  }
}

function touchEnd(e: MouseEvent & TouchEvent): void {
  // e.preventDefault();
  if (topHover && cardInfo.bottomCard) {
    topHover = false;
    callback("top");
  } else if (bottomHover && cardInfo.topCard) {
    bottomHover = false;
    callback("bottom");
  } else {
    topHover = false;
    bottomHover = false;
    if (leftHover && cardInfo.rightCard) {
      leftHover = false;
      callback("left");
    } else if (rightHover && cardInfo.leftCard) {
      rightHover = false;
      callback("right");
    } else {
      leftHover = false;
      rightHover = false;
      bottomHover = false;
      topHover = false;
      card.style.transform = `translate(0px, 0px) rotate(0deg)`;
    }
  }
  card.style.transition = `transform .2s ease-out`;
  isDown = false;

  setTimeout(() => {
    drag.now = false;
  }, 500);

  touchStartPos.x = 0;
  touchStartPos.y = 0;

  if (options.stamps.default) {
    stamps.reset();
  }

  if (decisionGroupDOM) {
    decisionGroupDOM.classList.remove("hide");
  }
}

function onResize(e: Event): void {
  stopDraggable();
  addDraggable(card, cardInfo, callback);
}

export function addDraggable(el: HTMLDivElement, cardDetails: _Int.Path.ICard, handler: (...args: any) => void): void {

  card = el;
  cardInfo = cardDetails;
  callback = handler;

  setGlobals();

  ["mousedown", "touchstart"].forEach((e) => {
    document.addEventListener(e, <any>touchDown);
  });

  ["mousemove", "touchmove"].forEach((e) => {
    document.addEventListener(e, <any>touchMove);
  });

  ["mouseup", "touchend"].forEach((e) => {
    document.addEventListener(e, <any>touchEnd);
  });

  window.addEventListener("resize", onResize);

}

export function stopDraggable(): void {

  ["mousedown", "touchstart"].forEach((e) => {
    document.removeEventListener(e, <any>touchDown);
  });

  ["mousemove", "touchmove"].forEach((e) => {
    document.removeEventListener(e, <any>touchMove);
  });

  ["mouseup", "touchend"].forEach((e) => {
    document.removeEventListener(e, <any>touchEnd);
  });

  window.removeEventListener("resize", onResize);

}